<template>
  <FeedFilterTag :on-click="handleClick">
    {{ data }}
  </FeedFilterTag>
</template>

<script setup>
import _ from 'lodash-es';
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  data: {
    type: String,
    required: true
  }
});

const handleClick = async () => {
  await useSearchParam(props.type, '');
}

</script>
